import script from "./SocialPagesFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialPagesFormPage.vue?vue&type=script&setup=true&lang=js"

import "./SocialPagesFormPage.vue?vue&type=style&index=0&id=557225fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-557225fe"]])

export default __exports__